<figure>
    <img src="{{assetsConst.authRight}}" alt="icon">
</figure>
<h2>Your Loved Academic Companion</h2>
<p>Empowering learners with personalized solutions</p>